import { zodResolver } from '@hookform/resolvers/zod'
import { useForm as _useForm } from 'react-hook-form'
import type { z } from 'zod'

type useFormProps = {
  schema: z.Schema<any, any>
}

export const useForm = (props: useFormProps) => {
  return _useForm({
    mode: 'all',
    resolver: props.schema ? zodResolver(props.schema) : undefined,
  })
}
